import { useCallback, useState } from 'react';
import { StorageKeyMap, StorageUtilities } from '@dealstack/frontend/shared/helper/storageUtils';

export const useLocalStorageModalController = (modalKey: keyof StorageKeyMap, mipID?: string) => {
	const [showModal, setShowModal] = useState(!StorageUtilities.getItem<boolean>(modalKey, mipID));

	const markModalAsSeen = useCallback(() => {
		StorageUtilities.setItem(modalKey, 'true', mipID);
		setShowModal(false);
	}, []);

	return { showModal, markModalAsSeen, setShowModal };
};
